import { motion } from "framer-motion";
import { ASSETS } from "../lib/assets";

export const BeforeAfter = () => {
    return (
        <section
            id="examples"
            data-testid="beforeafter-section"
            className="relative py-24 md:py-36 bg-neutral-50 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="text-center max-w-3xl mx-auto mb-14 md:mb-16"
                >
                    <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-neutral-500 mb-5">
                        / 02 — Het verschil
                    </p>
                    <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-black leading-[1.02]">
                        Video's{" "}
                        <span className="italic font-light text-neutral-400">
                            verkopen het.
                        </span>
                    </h2>
                    <p className="mt-5 text-sm md:text-base font-semibold tracking-wide text-black uppercase">
                        Meer aandacht. Betere presentatie. Sterkere eerste
                        indruk.
                    </p>
                    <p className="mt-5 text-base md:text-lg text-neutral-600 leading-relaxed px-2">
                        Dezelfde woning. Twee totaal verschillende eerste
                        indrukken. Welke zou jij willen plaatsen?
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch justify-items-center max-w-[1150px] mx-auto">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="relative group w-full max-w-[520px]"
                    >
                        <div className="relative zoom-media rounded-[28px] overflow-hidden border border-black/10 aspect-[9/16] bg-neutral-200 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.2)]">
                            <img
                                data-testid="before-image"
                                src={ASSETS.beforeAfterPhoto}
                                alt="Originele foto's"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute top-4 left-4 md:top-5 md:left-5 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white text-black text-[10px] md:text-xs font-bold tracking-wider uppercase shadow-lg">
                                Jouw foto's
                            </div>
                            <div className="absolute bottom-0 inset-x-0 p-5 md:p-6 bg-gradient-to-t from-black/70 to-transparent">
                                <p className="font-heading text-xl md:text-2xl font-bold tracking-tight text-white">
                                    Statische listing.
                                </p>
                                <p className="text-xs md:text-sm text-white/80 mt-1">
                                    Losse beelden, geen beweging.
                                </p>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.15 }}
                        className="relative group w-full max-w-[520px]"
                    >
                        <div className="absolute -inset-2 bg-black/10 blur-2xl rounded-[2rem] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                        <div className="relative rounded-[28px] overflow-hidden border-2 border-black aspect-[9/16] bg-black shadow-[0_30px_60px_-20px_rgba(0,0,0,0.4)]">
                            <iframe
                                data-testid="after-video"
                                src="https://player.vimeo.com/video/1187802460?autoplay=1&muted=1&loop=1&title=0&byline=0&portrait=0"
                                title="Marlea versie"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                                className="absolute inset-0 w-full h-full border-0"
                            />
                            <div className="absolute top-4 left-4 md:top-5 md:left-5 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-black text-white text-[10px] md:text-xs font-bold tracking-wider uppercase shadow-lg inline-flex items-center gap-2 z-10 pointer-events-none">
                                <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                                Marlea versie
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
